import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const Benefits = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {t.benefits.title}
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            {t.benefits.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {t.benefits.items.map((benefit, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 text-center border border-slate-100"
            >
              <div className="text-4xl mb-4">{benefit.icon}</div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 max-w-4xl mx-auto text-center">
          <p className="text-lg md:text-xl text-slate-700 leading-relaxed">
            {t.benefits.summary}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
